import { useDebounceFn } from '@vueuse/core'
import { theme } from '#tailwind-config'

export default function () {
  const { bodyLock, bodyUnlock } = useBodyLock()

  const breakpoints = useBreakpoints(theme.screens)
  const isScreenLg = breakpoints.greater('lg')

  // Main Menu
  const isVisible = useState('menu')
  const isBackdropVisible = useState('menuBackDrop')
  const isBodyLocked = useState('bodyLock')

  function menuHide() {
    if (!isScreenLg.value) {
      isVisible.value = false
      isBackdropVisible.value = false
    }
    if (isBodyLocked.value) {
      bodyUnlock()
    }
  }

  function menuShow() {
    isVisible.value = true
    isBackdropVisible.value = true

    if (!isBodyLocked.value) {
      bodyLock()
    }
  }

  function menuToggle() {
    if (!isVisible.value) {
      menuShow()
    } else {
      menuHide()
    }
  }

  function showOnlyMenu() {
    isVisible.value = true
  }

  const handleResize = useDebounceFn(() => {
    if (isScreenLg.value) {
      isVisible.value = true
      isBackdropVisible.value = false
    } else {
      isVisible.value = false
      isBackdropVisible.value = false

      if (isBodyLocked.value) {
        isBodyLocked.value = false
      }
    }
  }, 200)

  return {
    menuHide,
    menuShow,
    menuToggle,
    showOnlyMenu,
    handleResize
  }
}
